import "../styles/main.scss";
import "swiper/css";
import "swiper/css/effect-fade";
import './blocks.js';
import './auth.js';
import { initGallery } from './gallery.js';
import GLightbox from "glightbox";

document.body.classList.add("js");

// Main script loaded

function setupDownlaodGarrettStepOver() {
    let download_garrettEls = document.getElementsByClassName('download-garrett');
    if(download_garrettEls && download_garrettEls.length > 0) {
        // lets find active element
        let idx = -1;
        for(let i = 0; i < download_garrettEls.length; i++) {
            if(download_garrettEls[i].classList.contains('active')) {
                idx = i;
                break;
            }
        }

        let prevIdx = idx;

        // lets move on by one point
        idx++;
        idx = idx % download_garrettEls.length;

        if(prevIdx !== -1 && prevIdx < download_garrettEls.length) {
            download_garrettEls[prevIdx].classList.remove('active')
        }

        if(idx !== -1 && idx < download_garrettEls.length) {
            download_garrettEls[idx].classList.add('active')
        }
    }

    if(window.updateDownloadGarrettInstallerStepsAnimateTimeout) {
        clearTimeout(window.updateDownloadGarrettInstallerStepsAnimateTimeout);
    }

    window.updateDownloadGarrettInstallerStepsAnimateTimeout = setTimeout(setupDownlaodGarrettStepOver, 3000);
}

setupDownlaodGarrettStepOver();


/*
* MacOS vs Windows links
* */

const macosLinks = Array.from(document.querySelectorAll(".box-link.macos"));
const windowsLink = document.querySelector(".box-link.windows");

macosLinks.map((link) => {
    if (navigator.platform.indexOf("Mac") !== -1) {
        link.classList.add("active");
    }
});

if (windowsLink && navigator.platform.indexOf("Win") !== -1) {
    windowsLink.classList.add("active");
}

/* table double scroll when present */
const createDoubleScroll = (element) => {
    if (!element) return;

    const scrollbar = document.createElement('div');
    const innerDiv = document.createElement('div');

    scrollbar.appendChild(innerDiv);
    scrollbar.style.overflow = 'auto';
    scrollbar.style.overflowY = 'hidden';
    scrollbar.className = 'styled-scrollbar';

    innerDiv.style.width = `${element.scrollWidth}px`;
    innerDiv.style.paddingTop = '1px';
    innerDiv.appendChild(document.createTextNode('\xA0'));

    scrollbar.onscroll = () => element.scrollLeft = scrollbar.scrollLeft;
    element.onscroll = () => scrollbar.scrollLeft = element.scrollLeft;

    element.parentNode.insertBefore(scrollbar, element);
};

document.querySelectorAll('.wp-block-table').forEach(createDoubleScroll);

const fixDoubleScrollWidth = (element) => {
    if (!element) return;
    if(!element.closest('.wp-block-group')) return;

    element.closest('.wp-block-group').querySelector('.styled-scrollbar > div').style.width = `${element.scrollWidth}px`;
}

window.addEventListener('resize', function () {
    document.querySelectorAll('.wp-block-table').forEach(fixDoubleScrollWidth);
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('#btn-address-validation');
  if (!btn) return;

  const fields = btn.closest('.example-fields');
  if (!fields) return;

  btn.classList.add('is-validating');

  const observer = new MutationObserver(() => {
    btn.classList.remove('is-validating');
    observer.disconnect();
  });

  observer.observe(fields, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', () => {
  // Initialize gallery functionality
  initGallery();

  // ─── Promotional popups (per-popup cookies with priority fallthrough) ───
  //
  // PHP renders one hidden `.popup-slot` per matching popup, sorted by priority
  // (highest priority first). Each slot has a stable `data-popup-key` derived
  // from its content. We open the first slot whose `popupShown_<key>` cookie
  // isn't set, and only that popup's cookie is set on close/click. That way
  // closing today's top popup still lets tomorrow's second-priority popup
  // appear, and admins get clean per-banner dismissal.

  const POPUP_COOKIE_PREFIX = "popupShown_";
  const POPUP_COOKIE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

  const hasPopupCookie = (key) =>
    document.cookie
      .split(";")
      .some((item) => item.trim().startsWith(`${POPUP_COOKIE_PREFIX}${key}=`));

  const setPopupCookie = (key) => {
    const date = new Date();
    date.setTime(date.getTime() + POPUP_COOKIE_TTL_MS);
    document.cookie = `${POPUP_COOKIE_PREFIX}${key}=true; expires=${date.toUTCString()}; path=/`;
  };

  const openPopupSlot = (slot) => {
    if (!slot) return;
    const key = slot.dataset.popupKey || "default";

    // Measure off-screen for correct GLightbox sizing
    slot.style.position = "absolute";
    slot.style.visibility = "hidden";
    slot.style.display = "block";
    const contentWidth = slot.offsetWidth;
    slot.style.display = "none";
    slot.style.position = "";
    slot.style.visibility = "";

    const markSeen = () => setPopupCookie(key);

    GLightbox({
      elements: [{ content: slot.innerHTML, type: "inline" }],
      width: contentWidth + "px",
      height: "auto",
      openEffect: "zoom",
      closeEffect: "zoom",
      onOpen: () => {
        const lightboxContainer = document.querySelector(".glightbox-container");
        if (!lightboxContainer) return;
        lightboxContainer.classList.add("global-popup");
        lightboxContainer.dataset.popupKey = key;
        lightboxContainer.querySelectorAll("a").forEach((anchor) => {
          anchor.addEventListener("click", markSeen, { once: true });
        });
      },
      onClose: markSeen,
    }).open();
  };

  // Auto-open on page load: first popup whose cookie isn't set
  const slots = Array.from(document.querySelectorAll(".popup-slot"));
  const firstUnseen = slots.find(
    (slot) => !hasPopupCookie(slot.dataset.popupKey || "default")
  );
  if (firstUnseen) {
    openPopupSlot(firstUnseen);
  }

  // #popup hash links: always open the first slot (ignore cookie state)
  const openGlobalPopup = () => {
    const slot =
      document.querySelector(".popup-slot") ||
      document.getElementById("global-popup");
    if (!slot) {
      console.warn("Global popup element not found");
      return;
    }
    openPopupSlot(slot);
  };

  document.querySelectorAll('a[href="#popup"]').forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      openGlobalPopup();
    });
  });

  const checkHashAndOpen = () => {
    if (window.location.hash === "#popup") {
      setTimeout(() => openGlobalPopup(), 200);
    }
  };
  checkHashAndOpen();
  window.addEventListener("load", checkHashAndOpen);
  window.addEventListener("hashchange", () => {
    if (window.location.hash === "#popup") openGlobalPopup();
  });

});


/* */
